import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rma-shipping-arrivals',
  templateUrl: './rma-shipping-arrivals.component.html',
  styleUrls: ['./rma-shipping-arrivals.component.css']
})
export class RmaShippingArrivalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
